import { ItemProps, SectionsProps } from './types';
const contactUrgences: ItemProps[] = [
  {
    title: 'NumUrgencesYakada',
    param: '0801004747',
    action: 'call',
    icon: 'infoCovid',
  },
  {
    title: 'NumUrgencesSamu',
    param: '141',
    action: 'call',
    icon: 'alloSamu',
  },
  {
    title: 'NumUrgences300',
    param: '300',
    action: 'call',
    icon: 'infoCovid',
  },
];

const EmergencySection: SectionsProps = {
  type: 'NumUrgences',
  body: contactUrgences,
};
export default EmergencySection;
